import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChat = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_884_18045",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_884_18045)",
		children: /* @__PURE__ */ _jsx("path", { d: "M6.25 13.75H13.75V12.25H6.25V13.75ZM6.25 10.75H17.75V9.25H6.25V10.75ZM6.25 7.74995H17.75V6.25H6.25V7.74995ZM2.5 21.0384V4.3077C2.5 3.80257 2.675 3.375 3.025 3.025C3.375 2.675 3.80257 2.5 4.3077 2.5H19.6923C20.1974 2.5 20.625 2.675 20.975 3.025C21.325 3.375 21.5 3.80257 21.5 4.3077V15.6922C21.5 16.1974 21.325 16.625 20.975 16.975C20.625 17.325 20.1974 17.5 19.6923 17.5H6.03845L2.5 21.0384ZM3.99998 17.4154L5.41538 16H19.6923C19.782 16 19.8557 15.9711 19.9134 15.9134C19.9711 15.8557 20 15.782 20 15.6922V4.3077C20 4.21795 19.9711 4.14422 19.9134 4.08652C19.8557 4.02882 19.782 3.99997 19.6923 3.99997H4.3077C4.21795 3.99997 4.14423 4.02882 4.08653 4.08652C4.02883 4.14422 3.99998 4.21795 3.99998 4.3077V17.4154ZM3.99998 4.3077V3.99997V17.4154V4.3077Z" })
	})]
});
export default SvgChat;
